// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3h4Pd","badges":"styles_badges__3wHSu"};